import React from 'react';
export function VolumesDetail() {
  const fisicaVols = [{
    vol: '📘 Vol. 1',
    content: 'Team Sports Master-Vault Drills, tactical progressions, and session plans for the most popular team sports. From basic rules to advanced game strategy.'
  }, {
    vol: '📗 Vol. 2',
    content: 'Individual Excellence The complete guide to individual sport skills, fitness development, and personal performance tracking.'
  }, {
    vol: '📕 Vol. 3',
    content: 'The Minor Games Collection A vault of high-energy minor games, cooperative challenges, and active play sessions. The "never boring" volume.'
  }, {
    vol: '📙 Vol. 4',
    content: 'The Assessment Toolkit 50 plug-and-play assessment pages, rubrics, self-evaluation tools, and progress trackers ready to print and use.'
  }, {
    vol: '📘 Vol. 5',
    content: 'Visual Cues & Skill Cards The visual teaching encyclopedia. Instantly correct technique with clear, simple cues your students actually understand.'
  }, {
    vol: '📙 Vol. 6',
    content: 'The Yearly PE Planner The full-year curriculum map. Plan your entire school year by season, unit, skill level, and assessment checkpoint.'
  }];
  const bookEmojis = ['📘', '📗', '📕', '📙', '📘', '📙'];
  const formatVolText = (volText: string) => {
    return volText + ':';
  };
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border" data-id="element-256">
      <div className="max-w-5xl mx-auto" data-id="element-257">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-brand-ink mb-16" data-id="element-258">
          What you get in <span className="text-brand-accent" data-id="element-259">P.E. READY</span>
        </h2>
        <div className="max-w-2xl mx-auto flex flex-col gap-8" data-id="element-260">
          <div className="bg-brand-card border border-brand-border rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-261">
            <div className="mb-6" data-id="element-262">
              <h3 className="text-xl md:text-2xl font-heading font-bold uppercase mb-1 text-brand-accent" data-id="element-263">
                ⚡ 6 Teaching Volumes (High-Quality PDF)
              </h3>
              <p className="text-brand-muted text-sm" data-id="element-264">
                For PE teachers, coaches, and school sports professionals
              </p>
            </div>
            <div className="space-y-5" data-id="element-265">
              {fisicaVols.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-266">
                  <span className="text-xl leading-none mt-0.5" data-id="element-267">
                    {bookEmojis[i]}
                  </span>
                  <p className="text-brand-ink text-base leading-relaxed" data-id="element-268">
                    <span className="font-bold text-brand-accent mr-1" data-id="element-269">
                      {formatVolText(item.vol)}
                    </span>
                    {item.content}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}